import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapLabelLinkableComponent = React.lazy(function () {
    return import('../../bootstrap-components/components/BTLabelLinkableComponent');
});
var bootStrapLabelLinkableComponent = function (props) {
    return (React.createElement(BootStrapLabelLinkableComponent, __assign({}, props)));
};
var LabelLinkableComponent = function (props) {
    var componentToDisplay = bootStrapLabelLinkableComponent(props);
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapLabelLinkableComponent(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
LabelLinkableComponent.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default LabelLinkableComponent;
//# sourceMappingURL=LabelLinkableComponent.js.map